import React, { useContext } from "react";
import styled from "styled-components";
import GlobalContext from "../../Hooks/globalContext";
import languagePack from "../../Utils/language";

const Header = styled.div`
  width: 80%;
  padding: 45px 0px 5px 0px;
  border-bottom: 1px solid ${(props) => props.theme.darkGrey};
  margin-bottom: 25px;
  display: flex;
  justify-content: center;
`;

const HeaderTitle = styled.div`
  font-size: 17px;
  font-weight: bold;
  color: white;
`;

const AuthHeader = ({ page }) => {
  const { language } = useContext(GlobalContext);
  return (
    <Header>
      <HeaderTitle>
        {page === "register" && <>{languagePack("회원가입", language.state)}</>}
        {page === "forgot" && <>{languagePack("비밀번호 찾기", language.state)}</>}
        {page === "verify" && <>{languagePack("비밀번호 변경", language.state)}</>}
        {page === "login/verify" && <>{languagePack("이메일 인증", language.state)}</>}
        {page === "wallet" && <>{languagePack("지갑 생성", language.state)}</>}
      </HeaderTitle>
    </Header>
  );
};

export default AuthHeader;
